// extracted by mini-css-extract-plugin
module.exports = {"Video":"Video_Video__-kYs3","pipButton":"Video_pipButton__1Fw7O","pipIcon":"Video_pipIcon__25Nk4"};